module.exports = __webpack_public_path__ + "img/hatford_slide_1.46b85486.jpg";